"use client";

import type { ReactNode } from "react";
import { LazyMotion } from "framer-motion";
import { loadMotionFeatures } from "@/lib/motion-features";

/**
 * Required wrapper for the `m.*` components used throughout this site (in
 * place of the heavier `motion.*`) — without a LazyMotion ancestor, `m.*`
 * components fail to animate/render correctly. `strict` enforces that only
 * `m.*` (never `motion.*`) is used anywhere inside, so a future accidental
 * `motion.div` fails loudly at dev time instead of silently missing this
 * wrapper's benefit.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={loadMotionFeatures} strict>
      {children}
    </LazyMotion>
  );
}
